/**
 * Meta tags and site-search entry for `/about-us/family-of-companies/`
 * (`src/pages/about-us/family-of-companies/index.tsx`). The page's company list comes from
 * Contentful, not from this module.
 */
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";
import { FamilyCompaniesContent } from "@components/FamilyOfCompanies/Content";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";
import { FamilyHeroContent } from "@components/FamilyOfCompanies/FamilyHeroContent";

/**
 * SEO fields for the overview page, read by its `MetaHead`. The `fr` and `es` titles are the
 * English title. The company pages under it (`[slug].tsx`) have no meta module.
 */
export const MetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Ryerson Family of Companies - Ryerson",
		description:
			"The Ryerson Family of Companies consists of multiple brands within the organization, each of which offers distinct value and expertise that allow us to serve our customers better.",
		url: `/about-us/family-of-companies`,
		imageUrl: "/images/family-of-companies/FoC.png",
		company: true,
	},
	fr: {
		title: "Ryerson Family of Companies - Ryerson",
		description:
			`La famille d'entreprises Ryerson comprend plusieurs marques au sein de l'organisation, 
            chacune offrant une valeur et une expertise distincte, afin de mieux servir nos clients`,
		url: `/about-us/family-of-companies`,
		imageUrl: "/images/family-of-companies/FoC.png",
		company: true,
	},
	es: {
		title: "Ryerson Family of Companies - Ryerson",
		description:
			`La Familia de compañías Ryerson consiste en varias marcas dentro de la organización, 
            todas las cuales ofrecen valor y conocimiento técnico diversos que nos permiten servir mejor 
            a nuestros clientes`,
		url: `/about-us/family-of-companies`,
		imageUrl: "/images/family-of-companies/FoC.png",
		company: true,
	},
};

/**
 * The page's entry in the site-search index (`scripts/staticSearch.ts`). `content` is the hero
 * copy plus `components/FamilyOfCompanies/Content.tsx` → `FamilyCompaniesContent`, a hand-written
 * list of 14 companies that the page doesn't render. Search therefore indexes that list's
 * companies and copy, not the Contentful companies the page shows.
 */
export const PageContent: StaticPageContent = {
	meta: MetaObject,
	content: [FamilyHeroContent, FamilyCompaniesContent],
};
